import { getApiClient } from './client';
import type { User, UserProfile, UserWithProfile } from '../types/user';

export async function getUserProfile(tenant: string): Promise<UserWithProfile> {
  const client = getApiClient(tenant);
  return client.get<UserWithProfile>('/users/me');
}

export async function updateUserProfile(
  tenant: string,
  data: {
    name?: string;
    avatarUrl?: string;
    bio?: string;
    timezone?: string;
    preferences?: Record<string, unknown>;
    onboardingCompleted?: boolean;
  }
): Promise<UserWithProfile> {
  const client = getApiClient(tenant);
  return client.put<UserWithProfile>('/users/me', data);
}

export interface UserListResponse {
  users: Array<User & { createdAt: number; lastLoginAt: number | null }>;
  total: number;
  limit: number;
  offset: number;
}

export async function listUsers(
  tenant: string,
  options: { limit?: number; offset?: number; role?: string; cohort?: string } = {}
): Promise<UserListResponse> {
  const client = getApiClient(tenant);
  const params = new URLSearchParams();
  if (options.limit) params.set('limit', String(options.limit));
  if (options.offset) params.set('offset', String(options.offset));
  if (options.role) params.set('role', options.role);
  if (options.cohort) params.set('cohort', options.cohort);

  const query = params.toString();
  return client.get<UserListResponse>(`/users${query ? `?${query}` : ''}`);
}

export async function getUserById(
  tenant: string,
  userId: string
): Promise<UserWithProfile & { user: User & { createdAt: number; lastLoginAt: number | null } }> {
  const client = getApiClient(tenant);
  return client.get(`/users/${userId}`);
}

export async function updateUserRole(
  tenant: string,
  userId: string,
  role: 'user' | 'coach' | 'admin'
): Promise<{ user: User }> {
  const client = getApiClient(tenant);
  return client.put(`/users/${userId}/role`, { role });
}
